import { render, staticRenderFns } from "./LargeNotice.vue?vue&type=template&id=fd08062c"
import script from "./LargeNotice.vue?vue&type=script&lang=js"
export * from "./LargeNotice.vue?vue&type=script&lang=js"
import style0 from "./LargeNotice.vue?vue&type=style&index=0&id=fd08062c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports